import '@/website/website-theme-overrides.scss';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import SiteNavbar from '@/website/components/SiteNavbar.tsx';
import SiteFooter from '@/website/components/SiteFooter.tsx';

function Root() {
  return (
    <div className="website d-flex flex-column min-vh-100">
      <SiteNavbar />

      <main className="flex-grow-1">
        <Outlet />
        <ScrollRestoration />
      </main>

      <SiteFooter />
    </div>
  );
}

export default Root;
